/***************************************************************************************************
** redirectTo
***************************************************************************************************/

export default function redirectTo(url) {
  if (!url) return;

  window.location.assign(url);
}
